var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"score-set-rounds"},_vm._l((_vm.rounds),function(round){return _c('p',{key:'round-' + round.slug},[_c('a',{attrs:{"href":_vm.roundUrl(round.slug)}},[_vm._v("\n      "+_vm._s(round.name)),_c('br'),_vm._v("\n      "+_vm._s(round.startsAt)+"\n      "),(round.endsAt)?[_vm._v("— "+_vm._s(round.endsAt))]:_vm._e()],2)])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }